import { render, staticRenderFns } from "./ProjectForeignOrgaInfo.vue?vue&type=template&id=69450fe6&"
import script from "./ProjectForeignOrgaInfo.vue?vue&type=script&lang=ts&"
export * from "./ProjectForeignOrgaInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports